// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ca-j";
export var fulfillmentFormRail = "_ca-i";
export var headerTitleRow = "_ca-l";
export var orderDetailsWrapper = "_ca-g";
export var orderLinkTrigger = "_ca-2";
export var paymentInformationGrid = "_ca-q";
export var paymentSummaryColumn = "_ca-r";
export var phoneShipmentPickerButton = "_ca-e";
export var phoneShipmentPickerButtonContent = "_ca-f";
export var phoneShipmentPickerButtonWrapper = "_ca-d";
export var phoneShipmentPickerTrigger = "_ca-c";
export var shipmentContainer = "_ca-k";
export var shipmentDetailsMainPane = "_ca-h";
export var shipmentNavigationCard = "_ca-a";
export var shipmentNavigationEdgeTrigger = "_ca-6";
export var shipmentNavigationRail = "_ca-3";
export var shipmentNavigationRailEnter = "_ca-5";
export var shipmentNavigationRailHeader = "_ca-9";
export var shipmentNavigationRailOverlay = "_ca-4";
export var shipmentNavigationScrim = "_ca-7";
export var shipmentSummaryFact = "_ca-n";
export var shipmentSummaryGrid = "_ca-m";
export var shipmentSummaryMetadataRow = "_ca-o";
export var shipmentSummaryTags = "_ca-p";
export var shipmentWorkspace = "_ca-0";
export var shipmentWorkspaceBodyTablet = "_ca-8";
export var shipmentWorkspaceContent = "_ca-b";
export var shipmentWorkspaceHeader = "_ca-1";